/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_Sentence_CaseInputs */



/**
* | output |
* | --- |
* | "Text to Sentence Case" |
*
* @param {Text_To_Sentence_CaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_sentence_case = /** @type {((inputs?: Text_To_Sentence_CaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_Sentence_CaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte en casse de phrase")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text zu Satzgröße")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo in caso di frase")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразование текста в предложение с использованием регистра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Caso de texto a oración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本转句子大小写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを文頭大文字に変換する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पाठ से सजा का मामला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto para frase - Conversão de maiúsculas e minúsculas")
	return /** @type {LocalizedString} */ ("Text to Sentence Case")
});